import { NodeId } from 'ui/workflows/flowchart';
import { WorkflowsRootState } from '../ducks.types';

export const getEdges = (state: WorkflowsRootState) => state.workflow?.edges || [];
export const getDependentEdges = (state: WorkflowsRootState, nodeId: NodeId) =>
  state.workflow?.edges?.filter((x) => x.source === nodeId) || [];
